export enum ModalActionModel {
  SAVE = 'save',
  CANCEL = 'cancel',
  CLOSE = 'close',
}
